let FastMap = require("../../../node_modules/collections/fast-map");

export class MatchedDriveWaypointCollection extends FastMap {
    
    log(...args) {
        if (args[0] == 'error') {
            args.shift(); // Remove the 'error' bit.
            args[0] = `MatchedDriveWaypointCollection ` + args[0];
            return console.error.apply(console, args);
        }
        args[0] = `MatchedDriveWaypointCollection ` + args[0];
        console.log.apply(console, args);
    }
}
